import WarehouseSearch from './WarehouseSearch';

export default WarehouseSearch;
